import { useSelector } from 'react-redux';
import { selectReportSummaryTransactionsIsOpen } from '../../selectors';

export const useReportSummaryTransactionsIsOpen = (): boolean => {
  const selectedTransactionSectionsIsOpen = useSelector(selectReportSummaryTransactionsIsOpen);

  return selectedTransactionSectionsIsOpen;
};
